import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "banner w-full lg:h-18 h-60 relative" }
const _hoisted_3 = { class: "flex items-center flex-column w-full h-full" }
const _hoisted_4 = { class: "container mx-auto" }
const _hoisted_5 = { class: "flex flex-col items-center w-full container" }
const _hoisted_6 = { class: "flex justify-center mt-10" }
const _hoisted_7 = { class: "lg:pt-16 lg:px-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_divider_component = _resolveComponent("divider-component")!
  const _component_tabs_component = _resolveComponent("tabs-component")!
  const _component_gallery_component = _resolveComponent("gallery-component")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_divider_component, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Foto's")
                ])),
                _: 1,
                __: [1]
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(_component_tabs_component, {
        "current-tab": _ctx.activePage,
        onTogglePage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePage($event)))
      }, null, 8, ["current-tab"])
    ]),
    _createElementVNode("section", _hoisted_7, [
      (_ctx.activePage === 0)
        ? (_openBlock(), _createBlock(_component_gallery_component, {
            key: 0,
            pictures: _ctx.tabOnePictures
          }, null, 8, ["pictures"]))
        : _createCommentVNode("", true),
      (_ctx.activePage === 1)
        ? (_openBlock(), _createBlock(_component_gallery_component, {
            key: 1,
            pictures: _ctx.tabTwoPictures
          }, null, 8, ["pictures"]))
        : _createCommentVNode("", true),
      (_ctx.activePage === 2)
        ? (_openBlock(), _createBlock(_component_gallery_component, {
            key: 2,
            pictures: _ctx.tabThreePictures
          }, null, 8, ["pictures"]))
        : _createCommentVNode("", true)
    ])
  ]))
}